export default __webpack_public_path__ + "static/media/NgoziEzema.d0acd4df.svg";